import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const defaultState = {
  scores: [
    0,
    0,
    0,
    0
  ],
  finalStates: [
    {},
    {},
    {},
    {}
  ],
  locks: [
    false,
    false,
    true,
    true
  ],
  popups: {
    firstFail: false,
    analyticsChallenge: 0
  }
}

const storage = window.localStorage

const prefix = 'game2.'
for (const key in defaultState) {
  if (storage.getItem(prefix + key)) {
    defaultState[key] = JSON.parse(storage.getItem(prefix + key))
  }
}

const store = new Vuex.Store({
  state: defaultState,
  mutations: {
  },
  actions: {
    store: function () {
      for (const key in defaultState) {
        storage.setItem(prefix + key, JSON.stringify(defaultState[key]))
      }
    }
  }
})

// window.st = store

export default store
